<template>
  <div class="order-center">
    <div class="container">
      <div class="status-list">
        <div class="status-list-box">
          <div
            class="status-item"
            v-for="(v, k) in status_list"
            :key="`s` + k"
            :class="{ active: form_data.status === k }"
            @click="change_status(k)"
          >
            {{ v.name }}
            <template v-if="v.count > 0 || true">({{ v.count }})</template>
          </div>
        </div>
        <div class="filter-box">
          <Select
            v-model="selected_cate"
            placeholder="品类筛选"
            class="filter-select"
            @on-change="onCateChange"
          >
            <Option value="">全部</Option>
            <Option
              v-for="(item, index) in all_cate_list"
              :key="index"
              :value="item"
            >{{ item }}</Option>
          </Select>
          <Select
            v-model="form_data.order_type"
            placeholder="列表排序"
            class="filter-select"
            @on-change="onOrderChange"
          >
            <Option
              v-for="(item, index) in orderby_list"
              :key="index"
              :value="item.value"
            >{{ item.name }}</Option>
          </Select>
          <Select
            v-model="form_data.order_scale"
            placeholder="订单规模"
            class="filter-select"
            @on-change="onOrderScaleChange"
          >
            <Option
              v-for="(item, index) in order_scale_list"
              :key="index"
              :value="item.value"
            >{{ item.name }}</Option>
          </Select>
          <div class="search">
            <img
              src="../../assets/images/icon-search.png"
              alt=""
              class="icon-search"
            />
            <input
              type="text"
              placeholder="搜索款式名称、订单号或款号"
              v-model="form_data.keyword"
              class="input"
              @keyup.enter="search"
            />
          </div>
        </div>
      </div>

      <div v-if="loading" class="loading-wrapper">
        <Spin size="large" fix>
          <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
          <div>加载中...</div>
        </Spin>
      </div>
      <template v-else-if="display_order_list.length > 0">
        <div class="list">
          <div class="item">
            <div class="th">
              <div class="info">产品信息</div>
              <div class="quantity">数量</div>
              <div class="amount">订单金额</div>
              <div class="status">订单状态</div>
              <div class="action">操作</div>
            </div>
          </div>
          <div
            class="item td"
            v-for="(v, k) in display_order_list"
            :key="`or` + k"
            @click="go2detail(v.uuid)"
          >
            <div class="title">
              <span
                class="order-tag"
                :class="v.quantity > 10 ? 'tag-big' : 'tag-sample'"
                >{{ v.quantity > 10 ? "大货" : "样衣" }}</span
              >
              <span class="service-tag" v-if="v.service_type > 0">售后</span>
              订单号：{{ v.order_no }}
            </div>
            <div class="content td">
              <div class="info">
                <div
                  v-for="(vv, kk) in v.mtms"
                  class="sub-info"
                  :key="`si` + kk"
                >
                  <div class="left">
                    <img
                      :src="vv.design_data.category.image | default_img(false)"
                      alt=""
                      class="image"
                    />
                  </div>
                  <div class="right">
                    <div class="sub-name">
                      名称：{{ vv.design_data.category.name }}
                    </div>
                    <div class="sub-no">
                      款号：{{ vv.design_data.category.style_no }}
                    </div>
                    <div class="sub-category">
                      分类：{{ vv.design_data.category.product_category_name }}
                    </div>
                    <div class="sub-size">
                      尺码：{{ vv.spec_info.join("，") }}
                    </div>
                    <div class="sub-category">
                      性别：{{
                        vv.design_data.category.pat &&
                        vv.design_data.category.pat.sex_text
                          ? vv.design_data.category.pat.sex_text
                          : "-"
                      }}
                    </div>
                    <div
                      v-if="
                        [1, 5].includes(Number(v.status)) && v.service_type < 1
                      "
                      class="after-sale-btn"
                      @click.stop="onServiceApply(v)"
                    >
                      申请售后
                    </div>
                  </div>
                </div>
              </div>
              <div class="quantity">
                {{ v.quantity }}
              </div>
              <div class="amount">
                <template v-if="v.status === 2">{{ v.status_name }}</template>
                <template v-else>￥{{ v.total_price }}</template>
              </div>
              <div class="status" :class="oc(v)">
                {{ v.status_name }}
              </div>
              <div class="action">
                <div
                  class="btn btn-pay"
                  v-if="v.status_text === 'unpaid'"
                  @click.stop="pay(v.uuid,v.is_need_send_back)"
                >
                  立即付款
                </div>
                <div
                  class="btn btn-pay"
                  v-if="v.need_makeup"
                  @click.stop="makeup(v.uuid)"
                >
                  补差{{ v.makeup }}
                </div>
                <div
                  class="btn btn-pay"
                  v-if="v.status_text === 'unpaid'"
                  @click.stop="cancel(v.uuid)"
                >
                  取消订单
                </div>
                <div
                  class="btn btn-pay"
                  v-if="[1, 3, 5].includes(v.status)"
                  @click.stop="showChat(v)"
                >
                  取消订单
                </div>
                <div
                  class="btn btn-pay"
                  v-if="v.status_text === 'wait_confirm'"
                  @click.stop="confirm(v.uuid)"
                >
                  确认收货
                </div>
                <div
                  class="btn btn-pay"
                  v-if="
                    v.status_text === 'wait_delivery' &&
                    v.is_need_send_back &&
                    !v.self_send
                  "
                  @click.stop="onSubMeterials(v)"
                >
                  寄面辅料
                </div>
                <div
                  class="btn btn-pay"
                  v-if="v.status_text === 'complete' && !v.tax"
                  @click.stop="onApplyTax(v)"
                >
                  申请开票
                </div>
                <div
                  class="btn btn-pay"
                  v-if="v.status_text === 'complete' && v.tax"
                  @click.stop="onViewTax(v.tax)"
                >
                  {{ v.tax.tax_file ? "查看发票" : "开票处理中" }}
                </div>
                <div
                  class="btn btn-pay"
                  v-if="['wait_delivery', 'wait_confirm', 'complete'].includes(v.status_text)"
                  @click.stop="reOrder(v)"
                >
                  再次下单
                </div>
                <div class="btn-customer" @click.stop="showChat(v)">
                  联系客服
                </div>
              </div>
            </div>
          </div>
        </div>
        <Page
          :current="page"
          :page-size="size"
          :total="total"
          @on-change="changePage"
          show-total
          style="margin-top: 20px"
          show-sizer
          @on-page-size-change="changeSize"
          :page-size-opts="[5, 10, 20]"
        ></Page>
      </template>
      <template v-else>
        <img
          src="../../assets/images/no-data.png"
          style="width: 300px; display: block; margin: 0 auto"
          alt=""
        />
      </template>

      <popup
        :show.sync="is_popup_show"
        width="650px"
        height="auto"
        @on-close="close"
      >
        <h2>填写物流单号</h2>
        <div class="form" style="max-height: 520px; overflow-y: auto">
          <div
            class="form-group form-group-row"
            v-for="(item, index) in form_data_send.list"
            :key="index"
          >
            <div class="form-label">快递名称：</div>
            <div class="form-control">
              <select
                class="input input-sm"
                placeholder="请输入快递名称"
                v-model="item.logistics_name"
                :disabled="item.is_entry"
                @change="onChangeLogistics(index)"
              >
                <option v-for="(v, k) in logistics" :key="k" :value="v">
                  {{ v }}
                </option>
              </select>
            </div>
            <div class="form-label">快递单号：</div>
            <div class="form-control">
              <input
                type="text"
                class="input input-sm"
                placeholder="请输入快递单号"
                v-model="item.logistics_no"
                :readonly="item.is_entry"
              />
            </div>
            <div
              v-if="form_data_send.list.length > 1 && !item.is_entry"
              class="btn-delete"
              @click="removeLogistics(index)"
            >
              删除
            </div>
          </div>
          <div class="btn-add" @click="addLogistics">+ 添加物流</div>
          <div class="btn-submit" @click="save">保存</div>
        </div>
      </popup>
      <popup
        :show.sync="show_tax_form"
        width="490px"
        :height="form_data_tax.type == '2' ? '650px' : '320px'"
        @on-close="closeTaxForm"
      >
        <h2>申请开票</h2>
        <div class="form">
          <div class="form-group">
            <div class="form-label">开票类型：</div>
            <div class="form-control">
              <RadioGroup v-model="form_data_tax.type">
                <Radio :label="1">个人</Radio>
                <Radio :label="2">企业</Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">发票抬头：</div>
            <div class="form-control">
              <input
                type="text"
                class="input"
                placeholder="请输入发票抬头"
                v-model="form_data_tax.title"
              />
            </div>
          </div>
          <template v-if="form_data_tax.type == 2">
            <div class="form-group">
              <div class="form-label">纳税人识别号：</div>
              <div class="form-control">
                <input
                  type="text"
                  class="input"
                  placeholder="请输入纳税人识别号"
                  v-model="form_data_tax.tax_number"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">公司地址：</div>
              <div class="form-control">
                <input
                  type="text"
                  class="input"
                  placeholder="请输入公司地址"
                  v-model="form_data_tax.company_address"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">电话：</div>
              <div class="form-control">
                <input
                  type="text"
                  class="input"
                  placeholder="请输入电话号码"
                  v-model="form_data_tax.phone"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">开户行：</div>
              <div class="form-control">
                <input
                  type="text"
                  class="input"
                  placeholder="请输入开户行"
                  v-model="form_data_tax.bank_name"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">银行账号：</div>
              <div class="form-control">
                <input
                  type="text"
                  class="input"
                  placeholder="请输入银行账号"
                  v-model="form_data_tax.bank_account"
                />
              </div>
            </div>
          </template>
          <div class="btn-submit" @click="saveTax">保存</div>
        </div>
      </popup>

      <popup
        :show.sync="show_reorder_dialog"
        width="520px"
        height="auto"
        @on-close="closeReorderDialog"
      >
        <h2>请选择款式</h2>
        <div class="form">
          <div
            class="reorder-item"
            v-for="(item, index) in reorder_mtms"
            :key="index"
            @click="selectReorderItem(item)"
          >
            <img :src="item.design_data.category.image" alt="" class="image" />
            <div class="info">
              <div class="name">{{ item.design_data.category.name }}</div>
              <div class="style-no">款号：{{ item.design_data.category.style_no }}</div>
              <div class="category">分类：{{ item.design_data.category.product_category_name }}</div>
            </div>
          </div>
        </div>
      </popup>
      <!-- 客供面料提示 -->
      <popup
        :show.sync="show_custom_tips"
        width="471px"
        height="auto"
        @on-close="onCloseTips"
      >
        <div class="custom-tips-box">
          <div class="box-title">
            <div class="title-icon">i</div>
            <div class="title">温馨提示</div>
          </div>
          <div class="tips-content">客供面料，平台不支持快递到付，如需到付请勾选到付服务</div>
          <!-- 此处增加一个选项，用户可以选择是否同意到付服务,使用checkbox组件 -->
          <div class="checkbox">
            <Checkbox v-model="use_delivery_pay" />
            <!-- 点击文字也要让控制checkbox选中状态 -->
            <span @click="use_delivery_pay = !use_delivery_pay">我需要使用到付服务</span>
          </div>
          <div class="use-service">
            工厂收到该面料并确定快递费用后，平台客服将会联系您进行在线支付快该单递费用~
          </div>
          <div class="btn-box">
            <div class="cancel" @click="onCloseTips">取消</div>
            <div class="confirm" @click="onConfirmPayDelivery">确认</div>
          </div>
        </div>
      </popup>
      <Chat ref="chat"></Chat>
    </div>
  </div>
</template>

<script>
import {
  applyTax,
  CancelOrder,
  ConfirmOrder,
  OrderCategories,
  OrderCount,
  OrderList,
  Profile,
  SendFabric,
  UpdatePayOnDelivery,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import logistics from "@/utils/logistics";
import axios from "axios";
const form_data_send = {
  logistics_name: "",
  logistics_no: "",
  uuid: "",
  list: [{ logistics_name: "", logistics_no: "", is_entry: false }],
};
export default {
  name: "OrderCenter",
  components: {
    Popup,
  },
  data() {
    return {
      size: 10,
      page: 1,
      total: -1,
      form_data: {
        keyword: "",
        status: "all",
        order_type: "desc",
        order_scale: "",
      },
      status_list: {
        all: { name: "全部订单", value: "all", count: 0 },
        wait_pay: { name: "待付款", value: "wait_pay", count: 0 },
        wait_delivery: { name: "待发货", value: "wait_delivery", count: 0 },
        wait_confirm: { name: "待收货", value: "wait_confirm", count: 0 },
        complete: { name: "已完成", value: "complete", count: 0 },
        cancel: { name: "已取消", value: "cancel", count: 0 },
      },
      order_list: [],
      is_popup_show: false,
      form_data_send: { ...form_data_send },
      form_data_tax: {
        order_id: "",
        type: 1,
        title: "",
        tax_number: "",
        company_address: "",
        phone: "",
        bank_name: "",
        bank_account: "",
      },
      show_tax_form: false,
      show_reorder_dialog: false,
      reorder_mtms: [],
      temp_order_no: "",
      logistics,
      selected_cate: "",
      orderby_list: [
        { name: "最新订单", value: "desc", order: "desc" },
        { name: "最早订单", value: "asc", order: "asc" },
      ],
      order_scale_list: [
        { name: "全部", value: "" },
        { name: "大货订单", value: "big" },
        { name: "样衣订单", value: "sample" },
      ],
      all_cate_list: [],
      loading: false,
      show_custom_tips: false,
      use_delivery_pay: false,
      curr_uuid:''
    };
  },
  computed: {
    cate_list() {
      const cateList = this.all_cate_list.map((cate) => ({
        product_category_name: cate,
      }));
      return [{ product_category_name: "全部" }, ...cateList];
    },
    display_order_list() {
      return this.order_list;
    },
    avatar() {
      return this.profile.avatar || require("@/assets/images/avatar.png");
    },
  },
  watch: {
    "form_data.status": function (newVal, oldVal) {
      this.form_data.status = newVal;
      this.page = 1;
      this.getOrderList();
    },
  },
  mounted() {
    this.$refs.tips.open();
    this.change_status("all");
    axios
      .all([this.getProfile(), this.getOrderList(), this.getCateList()])
      .then(axios.spread(() => {}));
  },
  methods: {
    onCloseTips(){
      this.show_custom_tips = false;
      this.use_delivery_pay = false;
    },
    async onConfirmPayDelivery(){
      const uuid = this.curr_uuid;
      // return;
      const {use_delivery_pay} = this;
      try {
        const {code,msg} = await UpdatePayOnDelivery({ uuid, is_pay_on_delivery: use_delivery_pay ? 1 : 0 });
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        this.pay(uuid,true,true);
      } catch (error) {
        console.error('Update pay on delivery failed:', error);
      }
    },
    onServiceApply({ uuid, fixes }) {
      if (fixes.length > 0) {
        this.$layer.msg("当前订单已经申请售后~");
        return;
      }
      this.$router.push({
        name: "SampleOrderFixApply",
        query: {
          uuid,
        },
      });
    },
    onChangeLogistics(index) {
      const item = this.form_data_send.list[index];
      if (item.logistics_name === "送货上门") {
        item.logistics_no = this.temp_order_no;
      }
      console.log("form_data_send", this.form_data_send);
    },
    onViewTax({ status, tax_file }) {
      if (status == 1) {
        this.$layer.msg("发票开具中.请耐心等待...");
        return;
      }
      if (!tax_file || !tax_file.startsWith("http")) {
        this.$layer.msg("发票文件异常,请联系客服");
        return;
      }
      window.open(tax_file, "_blank");
    },
    onApplyTax(data) {
      console.log("data-apply-tax", data);
      this.form_data_tax.order_id = data.order_id;
      this.show_tax_form = true;
    },
    closeTaxForm() {
      this.form_data_tax = {
        order_id: "",
        type: 1,
        title: "",
        tax_number: "",
        company_address: "",
        phone: "",
        bank_name: "",
        bank_account: "",
      };
      this.show_tax_form = false;
    },
    async saveTax() {
      try {
        const { form_data_tax } = this;
        console.log("form_data_tax", form_data_tax);
        await applyTax(form_data_tax);
        this.$layer.msg("申请开票成功,请耐心等待.");
        this.closeTaxForm();
        this.getOrderList();
      } catch (e) {
        console.log("err-save-tax", e);
      }
    },
    showChat(v) {
      this.$refs.chat.showChat({
        uuid: v.uuid, // 订单uuid
        image: v.mtm.design_data.category.image,
        name: v.mtm.design_data.category.name,
        from: "order",
        //order_no: v.order_no, // 供第三方客服URL使用
        //style_number: v.mtm.style_number, // 供第三方客服URL使用
      });
    },
    save() {
      this.form_data_send.logistics_name = this.form_data_send.list
        .map((i) => i.logistics_name)
        .join(",");
      this.form_data_send.logistics_no = this.form_data_send.list
        .map((i) => i.logistics_no)
        .join(",");
      SendFabric(this.form_data_send)
        .then(() => {
          this.$layer.msg(`保存成功`);
          this.is_popup_show = false;
          this.form_data_send = { ...form_data_send };
          return this.getOrderList();
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        });
    },
    close() {
      this.is_popup_show = false;
      this.form_data_send = { ...form_data_send };
    },
    onSubMeterials(data) {
      console.log("data-sub-meterials", data);
      const { uuid, order_no } = data;
      this.form_data_send.uuid = uuid;
      this.temp_order_no = order_no;
      // 如果已有逗号分隔数据，拆分为多组
      if (
        this.form_data_send.logistics_name &&
        this.form_data_send.logistics_name.includes(",")
      ) {
        const names = this.form_data_send.logistics_name.split(",");
        const nos = (this.form_data_send.logistics_no || "").split(",");
        this.form_data_send.list = names.map((name, i) => ({
          logistics_name: name,
          logistics_no: nos[i] || "",
          is_entry: false,
        }));
      } else if (
        this.form_data_send.logistics_name ||
        this.form_data_send.logistics_no
      ) {
        this.form_data_send.list = [
          {
            logistics_name: this.form_data_send.logistics_name,
            logistics_no: this.form_data_send.logistics_no,
            is_entry: false,
          },
        ];
      } else {
        this.form_data_send.list = [
          { logistics_name: "", logistics_no: "", is_entry: false },
        ];
      }
      this.is_popup_show = true;
    },
    addLogistics() {
      this.form_data_send.list.push({
        logistics_name: "",
        logistics_no: "",
        is_entry: false,
      });
    },
    removeLogistics(index) {
      if (
        this.form_data_send.list.length > 1 &&
        !this.form_data_send.list[index].is_entry
      ) {
        this.form_data_send.list.splice(index, 1);
      }
    },
    search() {
      this.getOrderList();
    },
    confirm(uuid) {
      this.$DModal.confirm({
        content: "该订单确认收货么？",
        onOK: () => {
          ConfirmOrder({ uuid })
            .then(() => {
              this.$layer.msg(`操作成功`);
            })
            .finally(() => {
              this.getOrderList();
            });
        },
      });
    },
    cancel(uuid) {
      this.$DModal.confirm({
        content: "该订单确认取消么？",
        onOK: () => {
          CancelOrder({ uuid })
            .then(() => {
              this.$layer.msg(`操作成功`);
            })
            .finally(() => {
              this.getOrderList();
            });
        },
      });
    },
    pay(uuid,need_send_back,confirm_delivery=false) {
      if(need_send_back && !confirm_delivery){
        this.show_custom_tips = true;
        this.curr_uuid = uuid;
        return;
      }
      if(confirm_delivery){
        this.show_custom_tips = false;
      }
      this.$router.push({
        name: "WorkBenchCheckout",
        query: { uuid },
      });
      // this.$router.push({name: 'CashDesk', query: {uuid, pay_type: 'wechat'}})
    },
    makeup(uuid) {
      this.$router.push({
        name: "Makeup",
        query: { uuid, pay_type: "wechat" },
      });
    },
    reOrder(order) {
      const mtms = order.mtms || [];
      const validMtms = mtms.filter(mtm => mtm.design && mtm.design.uuid);
      if (validMtms.length === 0) {
        this.$layer.msg("未找到可再次下单的款式");
        return;
      }
      if (validMtms.length === 1) {
        this.checkout(validMtms[0].design.uuid);
        return;
      }
      this.reorder_mtms = validMtms;
      this.show_reorder_dialog = true;
    },
    selectReorderItem(item) {
      if (item.design && item.design.uuid) {
        this.checkout(item.design.uuid);
        this.closeReorderDialog();
      }
    },
    closeReorderDialog() {
      this.show_reorder_dialog = false;
      this.reorder_mtms = [];
    },
    checkout(uuid) {
      const query = { uuid, from: "design" };
      this.$router.push({
        name: "WorkBenchSummary",
        query: query,
      });
    },
    oc(v) {
      return [v.status_text];
    },
    go2detail(uuid) {
      this.$router.push({ name: "OrderDetail", query: { uuid } });
    },
    changePage(page) {
      this.page = page;
      this.getOrderList();
    },
    changeSize(size) {
      this.page = 1;
      this.size = size;
      this.getOrderList();
    },
    change_status(s) {
      this.form_data.status = s;
    },
    onCateChange(value) {
      this.selected_cate = value;
      this.page = 1;
      this.getOrderList();
    },
    onOrderChange(value) {
      this.form_data.order_type = value;
      this.page = 1;
      this.getOrderList();
    },
    onOrderScaleChange(value) {
      this.form_data.order_scale = value;
      this.page = 1;
      this.getOrderList();
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    async getCateList() {
      return OrderCategories().then((response) => {
        this.all_cate_list = response.data;
      });
    },
    async getOrderList() {
      this.loading = true;
      this.order_list = [];
      const params = { ...this.form_data, page: this.page, size: this.size };
      if (this.selected_cate) {
        params.product_category = this.selected_cate;
      }
      return OrderList(params)
        .then((response) => {
          this.order_list = response.data.list;
          this.total = response.data.total;
          return OrderCount(params);
        })
        .then((response) => {
          console.log('response',response);
          for (let code in response.data) {
            console.log('code',code,'status_list',this.status_list[code]);
            if (this.status_list[code]) {
              this.status_list[code].count = response.data[code];
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-center {
  width: 100%;
  .container {
    padding: 0 70px 0 30px;
    background: white;

    .status-list {
      padding: 20px 0;
      display: flex;
      align-content: flex-start;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      flex-wrap: wrap;
      row-gap: 15px;
      .status-list-box {
        display: flex;
        flex-wrap: wrap;
        column-gap: 10px;
        row-gap: 10px;
      }
      .status-item {
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        text-align: center;
        flex-shrink: 0;
        cursor: pointer;
        padding: 0 15px;
        &.active {
          background: #fa3d5a;
          border-radius: 5px;
          color: white;
        }
        &:first-child {
          margin-left: 0;
        }
      }
      .filter-box {
        display: flex;
        align-items: center;
        column-gap: 10px;
        flex-wrap: wrap;
        row-gap: 10px;
        .filter-select {
          width: 120px;
          flex-shrink: 0;
          ::v-deep .ivu-select-selection {
            border-radius: 20px;
            border: 1px solid #e8e8e8;
            background: #fafafa;
            height: 36px;
            line-height: 36px;
            transition: all 0.3s;
            &:hover {
              border-color: #fa3d5a;
              background: #fff;
            }
          }
          ::v-deep .ivu-select-focused .ivu-select-selection {
            border-color: #fa3d5a;
            box-shadow: 0 0 0 2px rgba(250, 61, 90, 0.1);
          }
          ::v-deep .ivu-select-selected-value {
            height: 36px;
            line-height: 36px;
            font-size: 13px;
            color: #333;
            padding-right: 25px;
          }
          ::v-deep .ivu-select-arrow {
            color: #999;
          }
        }
      }
      .search {
        position: relative;
        flex-shrink: 0;
        .icon-search {
          position: absolute;
          top: 15px;
          left: 15px;
          width: 18px;
          height: 18px;
        }
        .input {
          width: 220px;
          height: 40px;
          line-height: 40px;
          border-radius: 20px;
          padding-left: 45px;
          background: #f3f4f6;
          font-size: 13px;
          outline: none;
          border: none;
        }
      }
    }

    .list {
      padding: 10px 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .item {
        // width: 1500px;
        width: 100%;
        margin: 5px 0;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #ebedf2;
        &:first-child {
          border: none;
        }
        cursor: pointer;
        color: #191a1c;
        overflow: hidden;
        .title {
          height: 42px;
          line-height: 42px;
          padding-left: 20px;
          color: #191a1c;
          background: #edeff2;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          display: flex;
          align-items: center;
          .order-tag {
            display: inline-block;
            padding: 2px 10px;
            border-radius: 4px;
            color: #fff;
            font-size: 12px;
            margin-right: 10px;
            line-height: 1.5;
          }
          .tag-big {
            background: #ff6b35;
          }
          .tag-sample {
            background: #2ecc71;
          }
          .service-tag {
            display: inline-block;
            padding: 2px 10px;
            border-radius: 4px;
            color: #fff;
            font-size: 12px;
            margin-right: 10px;
            line-height: 1.5;
            background: #ff5967;
          }
        }
        .th {
          display: flex;
          flex-wrap: nowrap;
          line-height: 52px;
          text-align: center;
          background: #f6f7fa;
          border-radius: 5px 5px 0px 0px;
          border: 1px solid #e3e3e3;
          &:first-child {
            border: none;
          }
          color: #575859;
          font-size: 14px;
          overflow: hidden;
          .info {
            width: 730px;
          }
          .quantity {
            width: 200px;
          }
          .amount {
            width: 200px;
          }
          .status {
            width: 200px;
          }
          .action {
            width: 200px;
          }
        }
        .content {
          display: flex;
          flex-wrap: nowrap;
          text-align: center;
          align-items: center;
          .info {
            width: 730px;
            border-right: 1px solid #e3e3e3;
            .sub-info {
              display: flex;
              // height: 150px;
              padding: 10px 10px 5px 10px;
              .left {
                display: flex;
                align-items: center;
                .image {
                  width: 110px;
                  height: 110px;
                  object-fit: cover;
                }
              }
              .right {
                text-align: left;
                padding: 10px;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                .sub-name {
                  width: 100%;
                  color: #666;
                  font-size: 14px;
                }
                .sub-no {
                  width: 100%;
                  color: #666;
                  font-size: 14px;
                }
                .after-sale-btn {
                  width: 66px;
                  height: 26px;
                  border: 1px solid #e3e3e3;
                  border-radius: 2px;
                  line-height: 26px;
                  text-align: center;
                  color: #666;
                  font-size: 13px;
                  cursor: pointer;
                }
                .sub-category {
                  width: 100%;
                  color: #666;
                  font-size: 14px;
                }
                .sub-size {
                  width: 100%;
                  color: #666;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
                .sub-quantity {
                  width: 100%;
                  color: #666;
                }
              }
            }
          }
          .quantity {
            width: 200px;
            line-height: 150px;
            border-right: 1px solid #e3e3e3;
          }
          .amount {
            width: 200px;
            line-height: 150px;
            border-right: 1px solid #e3e3e3;
            font-weight: bold;
            font-size: 14px;
          }
          .status {
            width: 200px;
            line-height: 150px;
            border-right: 1px solid #e3e3e3;
            font-size: 14px;
            &.unpaid {
              color: #ff4400;
            }
            &.wait_delivery {
              color: #1572b8;
            }
            &.wait_confirm {
              color: #32a410;
            }
            &.cancel {
              color: #666666;
            }
            &.complete {
              color: #666666;
            }
          }
          .action {
            width: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            row-gap: 5px;
            .btn {
              width: 80px;
              height: 35px;
              line-height: 35px;
              text-align: center;
              border-radius: 5px;
              font-size: 14px;
              margin: 0 5px;
              &.btn-pay {
                background: #fa3d5a;
                color: white;
              }
            }
            .btn-customer {
              color: #3c3c3c;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
::v-deep .popup-modal {
  h2 {
    padding: 10px 20px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #f0f0f0;
  }
  .form {
    padding: 10px 0;
    .form-group {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      align-items: center;
      margin-top: 20px;
      &.form-group-row {
        flex-wrap: nowrap;
      }
      .form-label {
        width: 100px;
        font-size: 14px;
        color: #696a6a;
        text-align: right;
        flex-shrink: 0;
      }
      .form-control {
        position: relative;
        .input {
          width: 300px;
          height: 48px;
          line-height: 48px;
          border: 1px solid #d9d9d9;
          border-radius: 5px;
          padding: 0 10px;
          outline: none;
          font-size: 14px;
          &[readonly],
          &[disabled] {
            background: #f5f5f5;
            color: #999;
            cursor: not-allowed;
          }
          &.input-sm {
            width: 180px;
          }
          &:nth-of-type(2) .input-sm {
            width: 220px;
          }
        }
      }
    }

    .btn-add {
      margin: 15px 0 0 100px;
      width: 110px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      color: #666;
      font-size: 13px;
    }
    .btn-delete {
      position: static;
      margin-left: 10px;
      flex-shrink: 0;
      width: 50px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fa3d5a;
      cursor: pointer;
      font-size: 13px;
      border: 1px solid #fa3d5a;
      border-radius: 4px;
    }
    .btn-submit {
      margin: 40px auto 0;
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fa3d5a;
      color: white;
      border-radius: 6px;
      cursor: pointer;
    }
  }
  .custom-tips-box{
    width:100%;
    background:#fff;
    border-radius:10px;
    padding:26px 24px;
    position:relative;
    user-select:none;
    .box-title{
      display:flex;
      column-gap:10px;
      align-items:center;
      .title-icon{
        width:20px;
        height:20px;
        background:#0d99ff;
        border-radius:50%;
        color:#fff;
        text-align:center;
        line-height:20px;
      }
      .title{
        color:#0f1115;
        font-size:18px;
        font-weight:bold;
      }
    }
    .tips-content{
      font-size:16px;
      color:#333;
      margin-top:20px;
    }
    .checkbox{
      display:flex;
      align-items:center;
      column-gap:8px;
      cursor:pointer;
      span{
        color:#333;
        font-size:14px;
      }
    }
    .use-service{
      width:100%;
      background: #FFEFF0;
      border-radius: 8px 8px 8px 8px;
      padding:12px;
      color:#333;
      font-size:14px;
      margin-top:13px;
    }
    .btn-box{
      width:100%;
      display:flex;
      align-items:center;
      justify-content:center;
      column-gap:14px;
      margin-top:32px;
      .cancel{
        width: 166px;
        height: 44px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #E3E3E3;
        cursor:pointer;
        text-align:center;
        line-height:44px;
        font-size:16px;
        color:#666;
      }
      .confirm{
        width: 166px;
        height: 44px;
        background: #FF5967;
        border-radius: 4px 4px 4px 4px;
        color:#fff;
        cursor:pointer;
        text-align:center;
        line-height:44px;
        font-size:16px;
      }
    }
  }
}

.customer {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 200px;
  cursor: pointer;
}
.reorder-item {
  display: flex;
  align-items: center;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: border-color 0.2s;
  &:hover {
    border-color: #fa3d5a;
    background: #fafafa;
  }
  .image {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
    margin-right: 15px;
  }
  .info {
    flex: 1;
    .name {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      margin-bottom: 5px;
    }
    .style-no, .category {
      font-size: 12px;
      color: #999;
      line-height: 1.6;
    }
  }
}

.loading-wrapper {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .spin-icon-load {
    animation: ani-spin 1s linear infinite;
  }
}

@keyframes ani-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
